import { render, staticRenderFns } from "./TaskTag.vue?vue&type=template&id=b11d345e&scoped=true&"
import script from "./TaskTag.vue?vue&type=script&lang=js&"
export * from "./TaskTag.vue?vue&type=script&lang=js&"
import style0 from "./TaskTag.vue?vue&type=style&index=0&id=b11d345e&scoped=true&lang=css&"
import style1 from "./TaskTag.vue?vue&type=style&index=1&id=b11d345e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11d345e",
  null
  
)

export default component.exports